/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Save_Time_Feature_2Inputs */

const en_homepage_save_time_feature_2 = /** @type {(inputs: Homepage_Save_Time_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want to only listen to the abstract? Or skip to the results first? You can do that!`)
};

const es_homepage_save_time_feature_2 = /** @type {(inputs: Homepage_Save_Time_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Solo quieres escuchar el resumen? ¿O saltar a los resultados primero? ¡Puedes hacerlo!`)
};

/**
* | output |
* | --- |
* | "Want to only listen to the abstract? Or skip to the results first? You can do that!" |
*
* @param {Homepage_Save_Time_Feature_2Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_save_time_feature_2 = /** @type {((inputs?: Homepage_Save_Time_Feature_2Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Save_Time_Feature_2Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_save_time_feature_2(inputs)
	return en_homepage_save_time_feature_2(inputs)
});